var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMagnetIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 21"
}, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "magnet-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 .333h20v20H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#magnet-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.674 16.656a3.66 3.66 0 0 1-4.953.29 3.54 3.54 0 0 1-1.2-3.059 3.76 3.76 0 0 1 1.128-2.233l2.397-2.399a1.25 1.25 0 0 0-1.768-1.768L1.932 9.834a6.36 6.36 0 0 0-1.907 3.882 6.048 6.048 0 0 0 10.296 4.828l2.508-2.506a1.25 1.25 0 0 0-1.768-1.768zM17.634 1.556a6.19 6.19 0 0 0-8.099.672l-2.36 2.36a1.25 1.25 0 0 0 1.768 1.768l2.398-2.395a3.653 3.653 0 0 1 4.861-.35 3.55 3.55 0 0 1 .264 5.251l-2.507 2.507a1.25 1.25 0 0 0 1.767 1.768l2.508-2.507a6.054 6.054 0 0 0-.6-9.074"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7.176 11.371 3.884-3.884a1.25 1.25 0 1 1 1.768 1.768l-3.884 3.884a1.25 1.25 0 1 1-1.768-1.768"
}))));
export { SvgMagnetIcon as ReactComponent };
export default __webpack_public_path__ + "b2b3155ab67c76dcf8e2716e7f4135e0.svg";